<div class="map-container">
  <div #mapContainer id="map"></div>
  <!-- @if (mapLoading == true) {
    <div class="spin">
      <mat-spinner class="map-spinner"></mat-spinner>
    </div>
  } -->
  @if (showTowerLegend) {
    <div class='secondary-map-network-legend'>
      <div class='legend-scale'>
        <ul class='legend-labels'>
          <li><span style='border-radius: 25px;background:#FB5253;'></span>Current Tower Location</li>
          <li><span style='border-radius: 25px;background:#DA70D6;'></span>Previous Tower Location</li>
          <li><span style='border-radius: 25px;background:white;'></span>Tower Location</li>
        </ul>
      </div>
    </div>
  }
  @if (showNetworkProviderLegend) {
    <div class='global-map-network-legend'>
      <div class='legend-scale'>
        <ul class='legend-labels'>
          <li><span style='border-top: 6px solid #000000;'></span><div>Cell C</div></li>
          <li><span style='border-top: 6px solid #F3DB00;'></span><div>MTN</div></li>
          <li><span style='border-top: 6px solid #166BCE;'></span><div>Telkom</div></li>
          <li><span style='border-top: 6px solid #EB1900;'></span><div>Vodacom</div></li>
          <li><span style='border-top: 6px solid #666666;'></span><div>Other</div></li>
        </ul>
      </div>
    </div>
  }
</div>